import React from "react";
export const MainPageBody = React.forwardRef((props, ref) => (React.createElement("div", { className: "main-page-body", ref: ref, ...props }, props.children)));
MainPageBody.displayName = "MainPageBody";
export default MainPageBody;
